module.exports = __webpack_public_path__ + "static/media/Icons_Linkedin_dark.0c1667d0.svg";